/**
 * 暂存一些表单变量，用来判断用户是否有修改
 * @constructor
 */
import { ref, watch } from '@vue/composition-api';
import _ from 'lodash';
export function formEqualHandler(formData: Record<string, any>) {
  // make formData non reactive
  let preFormData = Object.assign({}, formData);
  const equalWithFormData = (formData: Record<string, any>) => {
    const nowFormData = Object.assign({}, formData);
    return _.isEqual(preFormData, nowFormData);
  };
  /**
   * 清理缓存的数据，同时更新最新的数据
   */
  const clearFormDataCache = () => {
    preFormData = Object.assign({}, formData);
    isEqual.value = equalWithFormData(formData);
  };
  const isEqual = ref(true);
  watch(formData, () => {
    isEqual.value = equalWithFormData(formData);
  });
  return {
    isEqual,
    clearFormDataCache,
  };
}
